import type { IPopupConfig } from "@/models";
import type { IGetRequest, IPostRequest, IRequest } from "@/utils/async";
import { ERequestStatus, requestInit } from "@/utils/async";
import { createReducer } from "@reduxjs/toolkit";
import type { IViewportDimensions } from "./landing-action-creators";
import { ILandingActions } from "./landing-actions";

export interface ILandingModel {
  landingPopup: IPopupConfig | null;
  getUserById: IGetRequest<any>;
  getImageByHash: IGetRequest<any>;
  postImageThrough: IPostRequest<any, any>;
  patchImageType: IPostRequest<any, any>;
  deleteImage: IRequest<any>;
  viewportDimensions: IViewportDimensions;
  deleteRequestStatus: ERequestStatus;
  uploaderProcessingList: string[];
}

const landingStoreInitialState: ILandingModel = {
  landingPopup: null,
  getUserById: requestInit(),
  getImageByHash: requestInit(),
  postImageThrough: requestInit(),
  deleteImage: requestInit(),
  patchImageType: requestInit(),
  viewportDimensions: {
    width: 0,
    height: 0,
    heightScreen: 0,
    isWidthResizing: false,
    isHeightResizing: false,
  },
  deleteRequestStatus: ERequestStatus.None,
  uploaderProcessingList: [],
};

/** Reducer */
export const landingReducer = createReducer(
  landingStoreInitialState,
  (builder) => {
    builder
      .addCase(ILandingActions.setViewportDimensions, (state, action: any) => {
        return {
          ...state,
          viewportDimensions: {
            ...state.viewportDimensions,
            ...action.payload,
          },
        };
      })
      .addCase(ILandingActions.initGetUserById, (state, action) => {
        return {
          ...state,
          getUserById: {
            status: ERequestStatus.Fetching,
          },
        };
      })
      .addCase(ILandingActions.successGetUserById, (state, action: any) => {
        return {
          ...state,
          getUserById: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      })
      .addCase(ILandingActions.failureGetUserById, (state, action) => {
        return {
          ...state,
          getUserById: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      })
      .addCase(ILandingActions.setLandingPopup, (state, action: any) => {
        return {
          ...state,
          landingPopup: action.payload,
        };
      })
      .addCase(ILandingActions.initPatchImageType, (state, action: any) => {
        return {
          ...state,
          patchImageType: {
            status: ERequestStatus.Fetching,
          },
        };
      })
      .addCase(ILandingActions.successPatchImageType, (state, action: any) => {
        return {
          ...state,
          patchImageType: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      })
      .addCase(ILandingActions.failurePatchImageType, (state, action: any) => {
        return {
          ...state,
          patchImageType: {
            error: action.payload.error,
            status: ERequestStatus.Error,
          },
        };
      })
      // [ILandingActions.Type.POST__IMAGE_THROUGH__RESET]: (state, action: any) => {
      //   return {
      //     ...state,
      //     postImageThrough: {
      //       status: ERequestStatus.None,
      //     },
      //     [`${action.payload.mediaType}RequestStatus`]: ERequestStatus.None,
      //   };
      // },
      .addCase(ILandingActions.initDeleteImage, (state, action: any) => {
        return {
          ...state,
          deleteImage: {
            status: ERequestStatus.Fetching,
          },
          deleteRequestStatus: ERequestStatus.Fetching,
        };
      })
      .addCase(ILandingActions.successDeleteImage, (state, action: any) => {
        return {
          ...state,
          deleteImage: {
            responseData: action.payload.response,
            status: ERequestStatus.Fetched,
          },
          deleteRequestStatus: ERequestStatus.Fetched,
        };
      })
      .addCase(ILandingActions.failureDeleteImage, (state, action: any) => {
        return {
          ...state,
          deleteImage: {
            error: action.payload.error,
            status: ERequestStatus.Error,
          },
          deleteRequestStatus: ERequestStatus.Error,
        };
      })
      .addCase(ILandingActions.setUploaderProcessing, (state, action: any) => {
        return {
          ...state,
          uploaderProcessingList: [
            ...state.uploaderProcessingList,
            action.payload.uploaderId,
          ],
        };
      })
      .addCase(
        ILandingActions.removeUploaderProcessing,
        (state, action: any) => {
          return {
            ...state,
            uploaderProcessingList: state.uploaderProcessingList.filter(
              (uploaderId) => uploaderId !== action.payload.uploaderId
            ),
          };
        }
      );
  }
);
